import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class AddToRecitalModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
    this.preview = null;
    this.loading = true;
    this.publishing = false;
    this.error = null;

    // Fetch dry-run preview
    this.fetchPreview();
  }
  className() {
    return 'AddToRecitalModal Modal--medium';
  }
  title() {
    return 'Add to Recital';
  }
  content() {
    if (this.loading) {
      return m('.Modal-body', m('p', 'Loading preview...'));
    }
    if (this.error) {
      return m('.Modal-body', m('.Alert.Alert--error', this.error));
    }
    const p = this.preview;
    return m('.Modal-body', [m('.Form-group', [m('strong', 'Post will be created as:'), m('p', [m('strong', 'Author: '), p.author_display, m('br'), m('strong', 'Post number: '), '#' + p.reserved_number, m('br'), m('strong', 'Timestamp: '), p.timestamp, m('br'), m('strong', 'Source: '), 'Post #' + p.source_post_number])]), m('.Form-group', [m('strong', 'Content:'), m('textarea.FormControl', {
      rows: 12,
      style: 'margin-top: 8px; white-space: pre-wrap; font-size: 13px; font-family: monospace;',
      value: this.editableContent,
      oninput: e => {
        this.editableContent = e.target.value;
      }
    })]), this.error ? m('.Alert.Alert--error', this.error) : null, m('.Form-group', {
      style: 'margin-top: 15px;'
    }, [Button.component({
      className: 'Button Button--primary',
      loading: this.publishing,
      onclick: () => this.performAdd()
    }, 'Add to Recital')])]);
  }
  fetchPreview() {
    const apiUrl = app.forum.attribute('apiUrl');
    const token = app.session.csrfToken;
    fetch(apiUrl + '/recitals/add-to-recital', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        postId: this.post.id(),
        dryRun: true
      })
    }).then(r => r.json()).then(result => {
      if (result.error) {
        this.error = result.error;
      } else {
        this.preview = result;
        this.editableContent = result.preview;
      }
      this.loading = false;
      m.redraw();
    }).catch(e => {
      this.error = e.message || 'Failed to load preview';
      this.loading = false;
      m.redraw();
    });
  }
  performAdd() {
    this.publishing = true;
    this.error = null;
    const apiUrl = app.forum.attribute('apiUrl');
    const token = app.session.csrfToken;
    fetch(apiUrl + '/recitals/add-to-recital', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        postId: this.post.id(),
        dryRun: false,
        content: this.editableContent
      })
    }).then(r => r.json()).then(result => {
      this.publishing = false;
      if (result.success) {
        app.alerts.show({
          type: 'success'
        }, 'Submission added to recital at post #' + result.post_number);
        this.hide();
        window.location.reload();
      } else {
        this.error = result.error || 'Failed';
        m.redraw();
      }
    }).catch(e => {
      this.publishing = false;
      this.error = e.message || 'Failed';
      m.redraw();
    });
  }
}
flarum.reg.add('pianotell-recitals', 'forum/components/AddToRecitalModal', AddToRecitalModal);